<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('dialog_title_order_info') || '订单详情'"
      direction="rtl"
      :size="900"
      @close="$refs.main.cancel()"
    >
      <EditForm ref="main" :orderCode="orderCode" @close="close()" />
    </el-drawer>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },

    orderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
